@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.components-date-picker {
  .CalendarDay,
  .CalendarDay--blocked-minimum-nights,
  .CalendarDay--blocked-out-of-range {
    border-color: @react-dates--calendar-day--border-color;
  }

  .CalendarDay {
    color: @react-dates--calendar-day--text-color;
    border: 0;
    font-size: 14px;
    line-height: 14px;
  }

  .CalendarDay--highlighted-calendar {
    color: @react-dates--calendar-day--highlighted--text-color;
  }

  .CalendarDay--highlighted-calendar:active {
    background: @react-dates--calendar-day--highlighted--active--background-color;
  }

  .CalendarDay--hovered {
    background: @react-dates--calendar-day--hovered--background-color;
  }

  .CalendarDay--blocked-minimum-nights,
  .CalendarDay--blocked-out-of-range {
    color: @react-dates--calendar-day--blocked--text-color;
  }

  .CalendarDay--selected-span {
    background: @react-dates--calendar-day--selected-span--background-color;
    border-color: @react-dates--calendar-day--selected-span--border-color;
  }

  .CalendarDay--selected-span.CalendarDay--hovered,
  .CalendarDay--selected-span:active {
    background: @react-dates--calendar-day--selected-span--background-color;
  }

  .CalendarDay--selected-span.CalendarDay--last-in-range {
    border-right: @react-dates--calendar-day--selected-span--border-color;
  }

  .CalendarDay--hovered-span,
  .CalendarDay--after-hovered-start {
    background: @react-dates--calendar-day--hovered--background-color;
    color: @react-dates--calendar-day--hovered--text-color;
  }

  .CalendarDay--hovered-span:active,
  .CalendarDay--after-hovered-start:active {
    background: @react-dates--calendar-day--hovered--active--background-color;
  }

  .CalendarDay--selected-start,
  .CalendarDay--selected-end,
  .CalendarDay--selected {
    background: @react-dates--calendar-day--selected--background-color;
  }

  .CalendarDay--selected-start:active,
  .CalendarDay--selected-end:active,
  .CalendarDay--selected:active {
    background: @react-dates--calendar-day--selected--background-color;
  }

  .CalendarDay--blocked-calendar {
    background: @react-dates--calendar-day--blocked-calendar--background-color;
    color: @react-dates--calendar-day--blocked-calendar--text-color;
  }

  .CalendarDay--blocked-calendar:active {
    background: @react-dates--calendar-day--blocked-calendar--background-color;
  }

  .CalendarMonth_caption {
    color: @react-dates--calendar-month--text-color;
    font-size: 14px;
    line-height: 14px;
    padding-top: 17px;
    padding-bottom: 27px;

    > * {
      font-weight: @normal;
    }
  }

  .DayPicker_weekHeader {
    top: 40px;
  }

  .DayPicker__week-header {
    color: @react-dates--day-picker--text-color;
  }

  .DayPicker--vertical-scrollable .DayPicker__week-header {
    border-bottom: 1px solid @react-dates--day-picker--border-color-1;
  }

  .DayPickerNavigation__prev--default,
  .DayPickerNavigation__next--default {
    border-color: @react-dates--day-picker--border-color-2;
    color: @react-dates--day-picker--text-color;
  }

  .DayPickerNavigation__prev--default:focus,
  .DayPickerNavigation__prev--default:hover,
  .DayPickerNavigation__next--default:focus,
  .DayPickerNavigation__next--default:hover {
    border-color: @react-dates--day-picker--border-color-1;
  }

  .DayPickerNavigation__prev--default:active,
  .DayPickerNavigation__next--default:active {
    background: @react-dates--day-picker--background-color;
  }

  .DayPickerNavigation--horizontal .DayPickerNavigation__prev--default svg,
  .DayPickerNavigation--horizontal .DayPickerNavigation__next--default svg {
    fill: @react-dates--icon-color;
  }

  .DayPickerNavigation--vertical .DayPickerNavigation__prev--default svg,
  .DayPickerNavigation--vertical .DayPickerNavigation__next--default svg {
    fill: @react-dates--icon-color;
  }

  .KeyboardShortcutRow__key {
    background: @react-dates--icon-color;
  }

  .DateInput--disabled {
    background: @react-dates--date-input--disabled--background-color;
  }

  .DateRangePicker__close svg {
    fill: @react-dates--icon-color;
  }

  .DateRangePicker__close:hover,
  .DateRangePicker__close:focus {
    color: @react-dates--date-range-picker--hover--icon-color;
  }

  .DateRangePickerInput {
    border-color: @react-dates--date-range-picker-input--border-color;
  }

  .DateRangePickerInput--disabled {
    background: @react-dates--date-range-picker-input--disabled--background-color;
  }

  .DateRangePickerInput__arrow svg {
    fill: @react-dates--icon-color;
  }

  .DateRangePickerInput__clear-dates svg {
    fill: @react-dates--icon-color;
  }

  .DateRangePickerInput__clear-dates:focus,
  .DateRangePickerInput__clear-dates--hover {
    background: @react-dates--date-range-picker-input--clear-dates--disabled--background-color;
  }

  .PresetDateRangePicker_button__calendar-icon svg {
    fill: @react-dates--icon-color;
  }

  .SingleDatePicker__close svg {
    fill: @react-dates--single-date-picker-close--icon-color;
  }

  .SingleDatePicker__close:hover,
  .SingleDatePicker__close:focus {
    color: @react-dates--single-date-picker-close--hover--icon-color;
  }

  .SingleDatePickerInput__clear-date:focus,
  .SingleDatePickerInput__clear-date--hover {
    background: @react-dates--single-date-picker-input--clear-date--hover--background-color;
  }

  // other styling

  .SingleDatePickerInput {
    border: 0;
    background: transparent;
    display: block;
  }

  .SingleDatePicker__picker--direction-left {
    //this important is needed because the js puts a left on the element.
    left: -100px !important;
  }

  .SingleDatePickerInput__calendar-icon {
    margin: 0;
    padding: 0;
    height: 30px;
    vertical-align: top;

    svg {
      height: 30px;
      width: 30px;
      fill: @react-dates--icon-color;
    }
  }

  .SingleDatePicker__picker {
    top: 100%;
    margin-top: 5px;
  }

  .SingleDatePicker_picker {
    position: static !important;
  }

  .DateInput,
  .DayPickerKeyboardShortcuts__show,
  .DateInput__input,
  .DateInput__display-text {
    display: none;
  }

  .DayPickerNavigation {
    display: flex;
    justify-content: space-between;
    padding: 0 22px;

    > * {
      padding: 0;
      margin: 0;
      border: 0;
      background: transparent;

      &:focus {
        outline: none;
      }

      &:hover {
        svg {
          background: @react-dates--day-picker-navigation--hover--icon-background-color;
          color: @react-dates--icon-color;
        }
      }

      svg {
        width: 14px;
        height: 18px;
        color: @react-dates--icon-color;
        display: inline-block;
        // this is in here because of a weird react-dates bug.
        margin-bottom: -4px;
      }
    }
  }

  .DayPicker__week-header li small {
    font-size: 14px;
    line-height: 14px;
  }

  .DayPickerNavigation--horizontal .DayPickerNavigation__prev,
  .DayPickerNavigation--horizontal .DayPickerNavigation__next {
    border-radius: 0;
    padding: 0;
  }

  .CalendarDay__button {
    border: 4px solid @react-dates--calendar-day-button--border-color;
  }

  .CalendarDay--selected {
    color: @react-dates--calendar-day-button--selected--text-color;
  }

  .SingleDatePickerInput_calendarIcon {
    height: 30px;
    margin: 0;
    padding: 0;
  }
  .CalendarDay__selected {
    color: @react-dates--calendar-day-button--selected--text-color;
    background: @react-dates--calendar-day-button--selected--background-color;
  }
  .DayPickerNavigation_button {
    background-color: transparent;
    border: 0;
    height: 30px;
    margin-top: 10px;
  }
}
